<telxl-panel cardClass="mb-2 border" [border]="false">
    <ng-template #cardHeader>
        <div class="d-flex w-100">
            <div class="w-100">
                <telxl-search
                    [searchText]="searchText()"
                    (searchTextChange)="searchChanged($event)"
                    id="template-listing-search"
                    class="w-100"
                />
            </div>
            <div class="ps-2">
                <telxl-button
                    colour="light"
                    size="sm"
                    (buttonClick)="onClose()"
                >
                    <i class="fa-solid fa-xmark"></i>
                </telxl-button>
            </div>
        </div>
    </ng-template>
    <ng-template #cardBody>
        <div class="row" #templates>
            <div [ngClass]="isBelow50PercentWidth() ? 'col-12' : 'col-6'">
                <ng-container
                    *ngTemplateOutlet="
                        previewing() && isBelow50PercentWidth()
                            ? PreviewPane
                            : ListPane
                    "
                ></ng-container>
            </div>
            @if (!isBelow50PercentWidth()) {
                <div class="col-6">
                    <ng-container
                        *ngTemplateOutlet="PreviewPane"
                    ></ng-container>
                </div>
            }
        </div>
    </ng-template>
</telxl-panel>

<ng-template #ListPane>
    <div class="border p-2 rounded template-list" [style.height]="height()">
        @if (loading()) {
            <div
                class="d-flex align-items-center justify-content-center h-100 w-100"
            >
                <telxl-loading size="3rem" />
            </div>
        } @else if (!hasTemplates()) {
            <div
                class="d-flex secondary-text flex-column align-items-center justify-content-center h-100"
            >
                <i class="fa-thin fa-face-zipper text-primary"></i>
                <div class="font-xl mt-1">No data!</div>
                <div class="mt-1">No templates found.</div>
            </div>
        } @else {
            @for (
                template of filteredTemplates() | sort: 'name';
                track template.id
            ) {
                <div
                    class="template-item d-flex align-items-center flex-nowrap"
                    [ngClass]="{
                        'border-bottom': !$last,
                        disabled: previewing()?.id === template.id,
                    }"
                >
                    <div class="flex-grow-1 min-w-0 pe-2">
                        <div
                            class="font-lg weight-medium template-name text-truncate"
                        >
                            {{ template.name }}
                        </div>
                        <div class="template-desc text-truncate">
                            {{ template.description }}
                        </div>
                    </div>
                    <div class="actions d-flex gap-2 flex-shrink-0 ms-2">
                        <telxl-button
                            colour="light"
                            size="sm"
                            (buttonClick)="preview(template)"
                        >
                            Preview
                        </telxl-button>
                        <telxl-button
                            colour="primary"
                            [outline]="true"
                            size="sm"
                            (buttonClick)="use(template)"
                        >
                            Use
                        </telxl-button>
                    </div>
                </div>
            }
        }
    </div>
</ng-template>

<ng-template #PreviewPane>
    <div class="border rounded overflow-y-auto" [style.height]="height()">
        @if (previewContent()) {
            <div class="d-flex flex-column pb-2">
                <div
                    class="d-flex align-items-center justify-content-between pt-3 pb-2 px-4 sticky-top bg-white"
                >
                    <div class="font-lg weight-medium">
                        {{ previewing()?.name }}
                    </div>

                    <div class="d-flex justify-content-end gap-1">
                        @if (isBelow50PercentWidth()) {
                            <telxl-button
                                colour="secondary"
                                size="sm"
                                [outline]="true"
                                (buttonClick)="previewing.set(null)"
                            >
                                Back
                            </telxl-button>
                        }
                        <telxl-button
                            colour="primary"
                            size="sm"
                            (buttonClick)="use(previewing()!)"
                        >
                            Use
                        </telxl-button>
                    </div>
                </div>
                <div class="mt-2 px-4" [innerHTML]="content() | unsafe"></div>
            </div>
        } @else {
            <div
                class="d-flex secondary-text flex-column align-items-center justify-content-center h-100"
            >
                <div class="text-muted">Preview a template.</div>
            </div>
        }
    </div>
</ng-template>
